import { Injectable } from "@nestjs/common";
import { CreateDlMasterReqDto, CreatePaRequestListDto, ProductionPlanModel, defaultDateFormat } from "@project-management-system/shared-models";
import { DLMasterEntity } from "./entities/dl-master.entity";
import { ProductionPlanEntity } from "./entities/dl-production-plan.entity";
import * as  moment from "moment";
import { PARequestListEntity } from "./entities/pa-request-list-entity";
import { PARequestChildEntity } from "./entities/pa-request-child-entity";

@Injectable()
export class DlModuleAdapter {


    convertDtoToMasterEntity(req: CreateDlMasterReqDto[], fileUid: string): DLMasterEntity[] {
        const empty: DLMasterEntity[] = [];
        for (const rec of req) {
            const entity = new DLMasterEntity();
            entity.itemName = rec.itemName
            entity.season = rec.season
            entity.helper = rec.helper
            entity.mainSampleCode2 = rec.mainSampleCode2
            entity.productionPlanTypeName = rec.productionPlanTypeName
            entity.fabricLeadTime = rec.fabricLeadTime
            entity.trimLeadTime = rec.trimLeadTime
            entity.poLeadTime = rec.poLeadTime
            entity.sam = rec.sam
            entity.keisu = rec.keisu
            entity.body = rec.body
            entity.sleeve = rec.sleeve
            entity.rib = rec.rib
            entity.ribNkBttm = rec.ribNkBttm
            entity.sJ = rec.sJ
            entity.fleece = rec.fleece
            entity.total = rec.total;
            entity.fileReferenceId = fileUid;
            if (rec.id) {
                entity.id = rec.id
            }
            empty.push(entity);

        }
        return empty;
    }

    convertDtoToProductionPlanEntity(
        req: ProductionPlanModel[],
        fileUid: string
    ): ProductionPlanEntity[] {
        const entities: ProductionPlanEntity[] = [];

        for (const rec of req) {
            const entity = new ProductionPlanEntity();
            entity.productionPlanId = rec.productionPlanId;
            entity.country = rec.country;
            entity.season = rec.season;
            entity.styleNo = rec.styleNo;
            entity.businessUnit = rec.businessUnit;
            entity.itemName = rec.itemName;
            entity.mainSampleCode = rec.mainSampleCode;
            entity.productionPlanTypeName = rec.productionPlanTypeName;
            entity.phase = rec.phase;
            const whDate: any = rec.whDate ? moment(rec.whDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.whDate = whDate;
            const contractDate: any = rec.contractDate ? moment(rec.contractDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.contractDate = contractDate;
            const exfDate: any = rec.exfDate ? moment(rec.exfDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.exfDate = exfDate;
            entity.fabOqyt = rec.fabOqyt;
            entity.trimOqty = rec.trimOqty;
            entity.poOqty = rec.poOqty;
            const fabRequestDate: any = rec.fabRequestDate ? moment(rec.fabRequestDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.fabRequestDate = fabRequestDate;
            const fabricAnswerDate: any = rec.fabricAnswerDate ? moment(rec.fabricAnswerDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.fabricAnswerDate = fabricAnswerDate;
            const fabricActualDate: any = rec.fabricActualDate ? moment(rec.fabricActualDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.fabricActualDate = fabricActualDate;
            const trimAnswerDate: any = rec.trimAnswerDate ? moment(rec.trimAnswerDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.trimAnswerDate = trimAnswerDate;
            const trimRequestDate: any = rec.trimRequestDate ? moment(rec.trimRequestDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.trimRequestDate = trimRequestDate;
            const trimActualDate: any = rec.trimActualDate ? moment(rec.trimActualDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.trimActualDate = trimActualDate;
            const poAnswerDate: any = rec.poAnswerDate ? moment(rec.poAnswerDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.poAnswerDate = poAnswerDate;
            const poRequestDate: any = rec.poRequestDate ? moment(rec.poRequestDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.poRequestDate = poRequestDate;
            const poActualDate: any = rec.poActualDate ? moment(rec.poActualDate, defaultDateFormat).format('YYYY-MM-DD') : null;
            entity.poActualDate = poActualDate;
            entity.createdAt = rec.createdAt;
            entity.createdUser = rec.createdUser;
            entity.updatedAt = rec.updatedAt;
            entity.updatedUser = rec.updatedUser;
            entity.versionFlag = rec.versionFlag;
            entity.isActive = rec.isActive;
            entity.companyCode = rec.companyCode;
            entity.unitCode = rec.unitCode;
            entity.sam = rec.sam;
            entity.keisu = rec.keisu;
            entity.samMaster = rec.samMaster;
            entity.fabBodyConsumption = Number.isNaN(rec.fabBodyConsumption) ? 0 : rec.fabBodyConsumption;
            entity.fabBodyRequirement = Number.isNaN(rec.fabBodyRequirement) ? 0 : rec.fabBodyRequirement;
            entity.fabConsumptionWithTrims = Number.isNaN(rec.fabConsumptionWithTrims) ? 0 : rec.fabConsumptionWithTrims;
            entity.fabRequirementWithTrims = Number.isNaN(rec.fabRequirementWithTrims) ? 0 : rec.fabRequirementWithTrims;

            entity.fileReferenceId = fileUid;
            entities.push(entity);
        }

        return entities;
    }



    convertPARequestListDtoToEntity(rec: CreatePaRequestListDto, fileUid: string): PARequestListEntity {
        const entity = new PARequestListEntity();
        entity.dept = rec.dept;
        entity.year = rec.year;
        entity.ssn = rec.ssn;
        entity.itemCode = rec.itemCode;
        entity.itemName = rec.itemName;
        entity.buCd = rec.buCd;
        entity.biz = rec.biz;
        entity.mainSampleCd = rec.mainSampleCd;
        entity.managementFactoryCd = rec.managementFactoryCd;
        entity.managementFactory = rec.managementFactory;
        entity.branchFactoryCd = rec.branchFactoryCd;
        entity.branchFactory = rec.branchFactory;
        entity.vendorCd = rec.vendorCd;
        entity.vendor = rec.vendor;
        entity.originalOrderProcessTarget = rec.originalOrderProcessTarget;
        entity.originalOrderProcessDone = rec.originalOrderProcessDone;
        entity.originalPh = rec.originalPh;
        entity.originalPublish = rec.originalPublish;
        entity.originalTrnsptMthd = rec.originalTrnsptMthd;
        entity.originalWh = rec.originalWh;
        entity.originalDl = rec.originalDl;
        entity.originalPlanQty = rec.originalPlanQty;
        entity.originalUpdateDate = rec.originalUpdateDate;
        entity.originalOrderPlanNumber = rec.originalOrderPlanNumber;
        entity.requestId = rec.requestId;
        entity.requestClassification = rec.requestClassification;
        entity.requestType = rec.requestType;
        entity.requestColor = rec.requestColor;
        entity.requestWh = rec.requestWh;
        entity.requestDl = rec.requestDl;
        entity.requestPlanQty = rec.requestPlanQty;
        entity.requestTrnsptMthd = rec.requestTrnsptMthd;
        entity.requestRequestDateJst = rec.requestRequestDateJst;
        entity.requestRequestUser = rec.requestRequestUser;
        entity.requestComment = rec.requestComment;
        entity.requestSalesRankOfBizAtLastWeek = rec.requestSalesRankOfBizAtLastWeek;
        entity.requestSalesRankOfDivAtLastWeek = rec.requestSalesRankOfDivAtLastWeek;
        entity.answerDlJst = rec.answerDlJst;
        entity.factoryAnswerAgrFlg = rec.factoryAnswerAgrFlg;
        entity.fileReferenceId = fileUid


        return entity
    }

    convertPAChildDtoToEntity(rec: CreatePaRequestListDto): PARequestChildEntity {
        const subEntity = new PARequestChildEntity();
        subEntity.factoryAnswerJdgRslt = rec.factoryAnswerJdgRslt;
        subEntity.factoryAnswerPsblPh = rec.factoryAnswerPsblPh;
        subEntity.factoryAnswerPsblWhShip = rec.factoryAnswerPsblWhShip;
        subEntity.factoryAnswerPsblWhAir = rec.factoryAnswerPsblWhAir;
        subEntity.factoryAnswerMinQty = rec.factoryAnswerMinQty;
        subEntity.factoryAnswerPsblQty = rec.factoryAnswerPsblQty;
        subEntity.factoryAnswerYarnDl = rec.factoryAnswerYarnDl;
        subEntity.factoryAnswerFabricDl = rec.factoryAnswerFabricDl;
        subEntity.factoryAnswerColorDl = rec.factoryAnswerColorDl;
        subEntity.factoryAnswerTrimDl = rec.factoryAnswerTrimDl;
        subEntity.factoryAnswerPoDl = rec.factoryAnswerPoDl;
        subEntity.factoryAnswerExf = rec.factoryAnswerExf;
        subEntity.factoryAnswerBdExf = rec.factoryAnswerBdExf;
        subEntity.factoryAnswerPoExf = rec.factoryAnswerPoExf;
        subEntity.factoryAnswerPrdMonth = rec.factoryAnswerPrdMonth;
        subEntity.factoryAnswerNgReason1 = rec.factoryAnswerNgReason1;
        subEntity.factoryAnswerNgReason2 = rec.factoryAnswerNgReason2;
        subEntity.factoryAnswerFreeComment = rec.factoryAnswerFreeComment;
        subEntity.factoryAnswerAnswerUser = rec.factoryAnswerAnswerUser;
        subEntity.factoryAnswerAnswerDate = rec.factoryAnswerAnswerDate;
        subEntity.orderDecisionDecision = rec.orderDecisionDecision;
        subEntity.orderDecisionOrderQty = rec.orderDecisionOrderQty;
        subEntity.orderDecisionAirUse = rec.orderDecisionAirUse;
        subEntity.dlYarnOrderQty = rec.dlYarnOrderQty;
        subEntity.dlYarnOrderNumber = rec.dlYarnOrderNumber;
        subEntity.dlYarnPlan = rec.dlYarnPlan ? moment(rec.dlYarnPlan).format('YYYY-MM-DD') : null;
        subEntity.dlYarnActual = rec.dlYarnActual ? moment(rec.dlYarnActual).format('YYYY-MM-DD') : null
        subEntity.dlFabricOrderQty = rec.dlFabricOrderQty;
        subEntity.dlFabricOrderNumber = rec.dlFabricOrderNumber;
        subEntity.dlFabricPlan = rec.dlFabricPlan;
        subEntity.dlFabricActual = rec.dlFabricActual;
        subEntity.dlColorOrderQty = rec.dlColorOrderQty;
        subEntity.dlColorOrderNumber = rec.dlColorOrderNumber;
        subEntity.dlColorPlan = rec.dlColorPlan;
        subEntity.dlColorActual = rec.dlColorActual ? moment(rec.dlColorActual).format('YYYY-MM-DD') : null;
        subEntity.dlTrimOrderQty = rec.dlTrimOrderQty;
        subEntity.dlTrimOrderNumber = rec.dlTrimOrderNumber;
        subEntity.dlTrimPlan = rec.dlTrimPlan;
        subEntity.dlTrimActual = rec.dlTrimActual;
        subEntity.dlPoOrderQty = rec.dlPoOrderQty;
        subEntity.dlPoOrderNumber = rec.dlPoOrderNumber;
        subEntity.dlPoPlan = rec.dlPoPlan;
        subEntity.dlPoActual = rec.dlPoActual;
        subEntity.factoryAnswerJdgRsltFirstTime = rec.factoryAnswerJdgRsltFirstTime;
        subEntity.factoryAnswerNgReason1FirstTime = rec.factoryAnswerNgReason1FirstTime;
        subEntity.factoryAnswerNgReason2FirstTime = rec.factoryAnswerNgReason2FirstTime;
        subEntity.factoryAnswerFreeCommentFirstTime = rec.factoryAnswerFreeCommentFirstTime;
        const childId = new PARequestListEntity();
        childId.requestId = rec.requestId
        subEntity.paRequestId = childId;
        return subEntity
    }

}